// heplers
import { generateNykaaUrl } from 'shared/helpers/utils/url';

// types
import { DynamicPageData } from 'shared/routes/DynamicPage/types';

// defs
interface GetMetaInfo {
  categoryURL: string;
  metaInfo: {
    description?: string;
    title?: string;
    keywords?: string[];
    imageUrl?: string;
  };
  pathname: string;
  isSearch: boolean;
  isOffer: boolean;
  dynamicPageSlug: string;
  dynamicPageData: DynamicPageData;
}

// constants
const NOINDEX = 'NOINDEX';
const NOINDEX_NOFOLLOW = 'noindex, nofollow';

export const getMetaInfo = ({
  categoryURL,
  metaInfo,
  pathname,
  isSearch,
  isOffer,
  dynamicPageSlug,
  dynamicPageData,
}: GetMetaInfo) => {
  let canonicalUrl = generateNykaaUrl(categoryURL || pathname);
  let metaTitle = metaInfo?.title;
  let metaDescription = metaInfo?.description;
  let metaKeywords = (metaInfo?.keywords && metaInfo?.keywords.join(', ')) || '';
  let noIndexNoFollowRobotMeta = '';

  if (isOffer) {
    noIndexNoFollowRobotMeta = NOINDEX;
  }

  if (isSearch && !dynamicPageSlug) {
    noIndexNoFollowRobotMeta = NOINDEX_NOFOLLOW;
  }

  if (dynamicPageSlug) {
    const { title, description, canonicalUrl: canonicalURL } = dynamicPageData;
    metaKeywords = '';
    metaTitle = title || '';
    metaDescription = description || '';
    canonicalUrl = canonicalURL;
  }

  return {
    metaTitle,
    metaDescription,
    metaKeywords,
    canonicalUrl,
    noIndexNoFollowRobotMeta,
  };
};
